module.exports = __webpack_public_path__ + "static/media/logo_jm.a225b932.svg";